import { Component, DoCheck, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';

import { MessageBoxType } from '@component/message-box';
import { FormWizardQuery } from '@state/form-wizard';

import { RenderedFormService } from '../rendered-form.service';
import { SectionComponent } from '../section/section.component';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-form-single',
  styleUrls: ['./form-single.component.scss'],
  templateUrl: './form-single.component.html'
})
export class FormSingleComponent implements DoCheck, OnInit {
  @Input() forceReadonly = false;
  @Input() form: any;

  @Output() flSubmit = new EventEmitter<any>();

  @ViewChildren(SectionComponent) sections: QueryList<SectionComponent>;

  isSubmitting$ = this.formWizardQuery.isSubmitting$;
  isAnySectionInvalid: boolean;
  messageBoxType = MessageBoxType;
  sectionForms: NgForm[] = [];
  userHasClickedSubmit: boolean;

  constructor(public renderedFormService: RenderedFormService, private formWizardQuery: FormWizardQuery) {}

  ngOnInit() {
    this.isAnySectionInvalid = false;
    this.userHasClickedSubmit = false;
  }

  ngDoCheck(): void {
    if (this.userHasClickedSubmit) this.updateFormValidity();
  }

  get visibleSections(): any[] {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.form.sections.filter((s) => this.renderedFormService.objectIsVisible(s));
  }

  get lastVisibleSection(): any {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.visibleSections[this.visibleSections.length - 1];
  }

  get ctaLabel(): string {
    if (this.lastVisibleSection.cta_label) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return this.lastVisibleSection.cta_label;
    }
    return 'Submit';
  }

  highlightInvalidFields(): void {
    for (let section of this.sections) {
      for (let controlKey of Object.keys(section.sectionForm.controls)) {
        section.sectionForm.controls[controlKey].markAsTouched();
      }
    }
  }

  submitForm(): void {
    this.userHasClickedSubmit = true;
    this.updateFormValidity();
    if (this.isAnySectionInvalid) return;
    this.flSubmit.emit();
  }

  updateFormValidity(): void {
    this.highlightInvalidFields();
    this.isAnySectionInvalid = this.sectionForms.some((sectionForm: NgForm) => sectionForm.form.invalid);
  }
}
